/** @format */
import apiClient from "./apiClient";
import { API_ENDPOINTS } from "../constants/api";
import { TCustomPresence } from "../redux-modules/declarations/maps/presences";

export const timebankApproveRequest = (
  presence: TCustomPresence,
  isStraordinario: boolean,
  negativeStraordinario: boolean = false,
  confermaTurnoParziale: boolean = false,
  isRol: boolean = false,
  confermaStraordinarioTurnoAssociato: boolean = false,
  hide_history: boolean
) => {
  return apiClient.post(API_ENDPOINTS.PRESENCES + "_timebank_approve", {
    presence_id: presence.original.id,
    is_straordinario: isStraordinario,
    negative_straordinario: negativeStraordinario,
    conferma_turno_parziale: confermaTurnoParziale,
    conferma_straordinario_turno_associato: confermaStraordinarioTurnoAssociato,
    hide_history: hide_history
  });
};

export const timebankUnapproveRequest = (presence: TCustomPresence, isStraordinario: boolean, hide_history: boolean) => {
  return apiClient.get(
    API_ENDPOINTS.TIMEBANK_DINIEGO +
      "/" +
      presence.modified?.id +
      "?is_straordinario=" +
      (isStraordinario ? 1 : 0) +
      "&hide_history="+(hide_history ? 1 : 0),
  );
};